// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_SEARCH_BUTTON = "Hledej";
export const FACET_SELECT_NO_OPTIONS = "Nelze vybrat \u017e\u00e1dnou hodnotu";
